import { useEffect, useCallback, useRef } from 'react';

export function useIdleTimeout(onIdle: () => void, idleMinutes = 30) {
  const stableOnIdle = useCallback(onIdle, [onIdle]);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    const channel = typeof BroadcastChannel !== 'undefined'
      ? new BroadcastChannel('a2r_idle_activity')
      : null;

    const resetTimer = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(stableOnIdle, idleMinutes * 60 * 1000);
    };

    const resetAndBroadcast = () => {
      resetTimer();
      channel?.postMessage({ type: 'activity' });
    };

    if (channel) {
      channel.addEventListener('message', (e: MessageEvent) => {
        if (e.data?.type === 'activity') resetTimer();
      });
    }

    const handleVisibility = () => {
      if (!document.hidden) resetTimer();
    };

    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    events.forEach(e => window.addEventListener(e, resetAndBroadcast, { passive: true }));
    document.addEventListener('visibilitychange', handleVisibility);
    resetTimer();

    return () => {
      clearTimeout(timerRef.current);
      events.forEach(e => window.removeEventListener(e, resetAndBroadcast));
      document.removeEventListener('visibilitychange', handleVisibility);
      channel?.close();
    };
  }, [stableOnIdle, idleMinutes]);
}
